import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {MENU_DATA} from "../../api/menu";
import {HiOutlineExternalLink} from "react-icons/hi";
import useHistoryStore from "../../stores/historyStore";
import {ROOT_PATH_PREFIX} from "../../const";
import IconFamilySVG from "./svg/IconFamilySVG";
import IconStudioSVG from "./svg/IconStudioSVG";
import IconOfficeSVG from "./svg/IconOfficeSVG";
import {GA_Event_Click} from "../../api/ga";
import IconSkipSVG from "./svg/IconSkipSVG";
import {BG_COLOR} from "../../styles/GlobalStyle";



/*
인트로 페이지 화면 제어
*/
const Intro = () => {
    const videoContainerRef = useRef();
    const videoRef = useRef();
    const menuRef = useRef(null);
    const introBtnRef = useRef();
    const navigate = useHistoryStore(state => state.navigate);

    const [hoveredSkip, setHoverSkip] = useState(false);

    //2뎁스 메뉴 선택 시
    const onClickSubMenuHandler = useCallback((item, sItem) => {
        if (sItem && sItem.pathname) {
            navigate(`${ROOT_PATH_PREFIX}/?pathname=${sItem.pathname}`);
        }
    }, [navigate]);

    function resizeHandler() {
        if (window.innerWidth >= 1600){
            introBtnRef.current.style.right = `${ (window.innerWidth - 1600) * 0.5 + 14}px`;
        }else{
            introBtnRef.current.style.right = `${14}px`;
        }
    }

    useEffect(()=>{
        window.addEventListener('resize', resizeHandler);
        resizeHandler();

        return()=>{
            window.removeEventListener('resize', resizeHandler);
        }
    }, []);

    return (
        <Wrapper>
            <div id='header'>
            </div>

            <div className="intro-video-container" ref={videoContainerRef}
            >
                <video
                    ref={videoRef}
                    className="intro-video"
                    crossOrigin="anonymous"
                    autoPlay
                    playsInline
                    loop
                    muted
                >
                    <source src={`${ROOT_PATH_PREFIX}/videos/update_20221205/intro.mp4`} type="video/mp4"/>
                </video>

                <button id="intro-video-skip-button"
                        className="closeBtn"
                        ref={introBtnRef}
                        onMouseOver={() => setHoverSkip(true)}
                        onMouseOut={() => setHoverSkip(false)}
                        onTouchStart={() => setHoverSkip(true)}
                        onTouchEnd={() => setHoverSkip(false)}
                        onClick={() => {
                            GA_Event_Click('click_intro_video_skip', '/');
                            navigate(`${ROOT_PATH_PREFIX}/?pathname=/family`);
                        }}
                >
                    <span style={{
                        color: hoveredSkip ? '#fff' : '#333'
                    }}>Überspringen</span>
                    <IconSkipSVG color={hoveredSkip ? '#fff' : '#333'}/>
                </button>
            </div>

            <div id='menu' ref={menuRef}>
                {MENU_DATA.map((item, idx) =>
                    <div className='oneDepth' key={idx}>
                        <div className='menu-header'>
                            <OneDepthMenu item={item}/>
                        </div>
                        <ul>
                            {item.subMenu.filter((data) => data.type !== 'label').map((sItem, sIdx) =>
                                <li key={sIdx} onClick={() => {
                                    onClickSubMenuHandler(item, sItem);
                                }}>
                                    {sItem.name.toUpperCase()}
                                </li>)}
                        </ul>
                    </div>
                )}
            </div>

            <div id='desc'>
                <span>Copyright © 2009-{new Date().getFullYear()} LG Electronics. All Rights Reserved</span>
            </div>
        </Wrapper>
    );
};

const OneDepthMenu = ({item}) => {

    const navigate = useHistoryStore(state => state.navigate);
    const [hovered, setHovered] = useState(false);

    //1뎁스 메뉴 선택 시
    const onClickMenuHandler = useCallback((item) => {
        if (item && item.pathname) {
            navigate(`${ROOT_PATH_PREFIX}/?pathname=${item.pathname}`);
        }
    }, [navigate]);

    return (
        <button
            id={`intro-${item.pathname.substring(1)}-btn`}
            className='container'
            style={{border: "none", background: "white"}}
            onMouseOver={() => setHovered(true)}
            onMouseOut={() => setHovered(false)}
            onTouchStart={() => setHovered(true)}
            onTouchEnd={() => setHovered(false)}
            onClick={() => {
                onClickMenuHandler(item);
            }}
        >
            {item.pathname === '/family' &&
                <IconFamilySVG className="icon" color={hovered ? '#a50034' : '#9c9b9b'} showBorder={true}/>}
            {item.pathname === '/studio' &&
                <IconStudioSVG className="icon" color={hovered ? '#a50034' : '#9c9b9b'} showBorder={true}/>}
            {item.pathname === '/office' &&
                <IconOfficeSVG className="icon" color={hovered ? '#a50034' : '#9c9b9b'} showBorder={true}/>}

            <h1 style={{color: hovered ? '#a50034' : '#000'}}>
                {item.name.toUpperCase()} {item.category === 'link' &&
                <HiOutlineExternalLink style={{marginLeft: '0.6rem'}}/>}
            </h1>
        </button>
    );
}

// noinspection CssUnknownTarget
const Wrapper = styled.div`

  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: ${BG_COLOR};
  //opacity: 0.8;
  overflow-y: auto;
  overflow-x: hidden;


  #header {
    padding-left: 8rem;
    height: 60px;
    color: black;
  }

  #lgHomeMenu {
    position: absolute;
    right: 0;
    top: 0;
    //background: #61dafb;
    padding: 1rem 3rem;
    color: #aaa;
    cursor: pointer;
    font-size: 2rem;
    font-weight: bold;

    :hover {
      color: #9c163f;
    }

    .link-icon {
      margin-left: 0.6rem;
      height: 3rem;
      width: 2rem;
      position: relative;
      left: 0;
      top: 0.8rem;
    }
  }

  .intro-video-container {
    width: 100%;
    height: 60rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    //background: red;
  }
  
  .intro-video {
    width: auto;
    height: 100%;
    object-fit: cover;
  }

  .closeBtn {
    background: #fff;
    border: none;
    height: 3rem;
    border-radius: 1.5rem;
    position: absolute;
    //right: 1.5rem;
    top: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 0 1.3rem;
    filter: drop-shadow(0 0 0.5rem rgba(100, 100, 100, 0.4));

    span {
      font-size: 1.5rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 0.4rem;
    }

    :hover {
      background: #a50034;

      span {
        color: #fff;
      }
    }
  }
  
  #banner {
    position: relative;
    top: 0;
    width: 100%;
    height: 165px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-image: url('img/intro_banner.jpg');
    background-size: cover;

    h1 {
      font-size: 5rem;
      max-font-size: 8rem;
      line-height: 4.5rem;
      margin-top: 0;
      margin-bottom: 1rem;
      text-align: center;
      font-weight: bold;
      letter-spacing: 0.2rem;
      //font-family: 'LG Smart', 'LG Smart Light', sans-serif;
    }

    h2 {
      font-size: 1.8rem;
      max-font-size: 2.5rem;
      line-height: 1.8rem;
      //font-family: "LG Smart Light";
      font-weight: lighter;
      margin-top: 0.5rem;
      margin-bottom: 0;
      text-align: center;
      letter-spacing: 0.1rem;
    }

    //img{
    //  //width: 100%;
    //  height: 100%;
    //}
  }

  #menu {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 2rem;

    .oneDepth {
      //background: #61dafb;
      width: 40rem;
      position: relative;
      left: 6rem;

      .menu-header {
        //background: #aaaaaa;
        margin: 5rem auto 3rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding-left: 6.5rem;

        .container {
          width: auto;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background: ${BG_COLOR} !important;
        }

        h1 {
          color: #333;
          cursor: pointer;
          margin-top: 1.5rem;
          font-size: 1.5rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        svg {
          width: 9rem;
          height: 9rem;
        }
      }
    }

    ul {
      font-size: 1.5rem;
      font-weight: 600;
      color: #aaaaaa;
      cursor: pointer;
      //width: 15rem;
      padding-left: 6.3rem;
      width: 100%;

      li {
        padding-bottom: 0.6rem;
        list-style-type: none;

        :hover {
          color: #9c163f;
        }
      }
    }
  }

  #desc {
    position: relative;
    top: 6rem;
    color: rgba(0, 0, 0, 0.5);
    font-size: 1.4rem;
    line-height: 2rem;
    height: 10rem;
    display: flex;
    justify-content: center;
    
    span{
      max-width: 1600px;
      width: 100%;
      //background: #61dafb;
      position: absolute;
      padding: 3rem;
    }
  }

  @media screen and (max-width: 1024px), screen and (max-height: 414px) {
    #header {
      //padding-left: 2rem;
      height: 0;
    }

    #lgHomeMenu {
      visibility: hidden;
    }
    #banner {
      //padding: 3rem;

      h1 {
        font-size: 4.1rem;
        text-align: left;
        margin: 0 0 0 2.5rem;
      }

      h2 {
        line-height: 2rem;
        text-align: left;
        margin: 1rem 2.5rem 0;
      }
    }

    #menu {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 0;

      .oneDepth {
        width: 100%;
        position: relative;
        border-bottom: 1px solid #eee;
        left:0;

        .menu-header {
          padding-left: 1.2rem;
          margin: 3rem auto 3rem;

          .container {
            flex-direction: row;
          }

          h1 {
            color: #333;
            cursor: pointer;
            padding-left: 2rem;
            font-size: 2.2rem;
          }

          svg {
            width: 6rem;
            height: 6rem;
          }
        }
      }

      .oneDepth + .oneDepth {
        .menu-header {
          h1 {
            border-left: none;
          }
        }
      }

      .oneDepth:last-child {
        border-bottom: none;
      }

      ul {
        font-size: 2.2rem;
        line-height: 3.3rem;
        color: #aaaaaa;
        cursor: pointer;
        padding-left: 3rem;
        margin: 0 0 3rem;
        width: 100%;
        position: relative;

        li {
          padding-bottom: 0.2rem;
          list-style-type: none;

          :hover {
            color: #9c163f;
          }
        }
      }
    }
  }

  @media screen and (max-width: 650px) and (orientation: portrait) {
    .intro-video-container {
      width: 100%;
      height: 30rem;
    }
  }
`;

export default Intro;
